import { Draft } from 'immer'
import { PlansCollectionResponse } from '../types'

export const removeDeleted = (planId: string) => {
  return (draftResponse: Draft<PlansCollectionResponse>) => {
    if (!draftResponse) return

    const remainingPlans = draftResponse.data.filter(
      (plan) => plan.id !== planId
    )

    draftResponse.data = remainingPlans

    return draftResponse
  }
}
